import { render } from "./CouponCollection.vue?vue&type=template&id=0348ba50&scoped=true"
import script from "./CouponCollection.vue?vue&type=script&lang=js"
export * from "./CouponCollection.vue?vue&type=script&lang=js"

import "./CouponCollection.vue?vue&type=style&index=0&id=0348ba50&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0348ba50"]])

export default __exports__